import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'DossierHomologation/ProducerList', method: 'GET', body: null, token: token })
}
